export default "__VITE_ASSET__BUWDwqKM__"